import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Headphones, Sparkles } from 'lucide-react';
export function OfferSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-dark text-white text-center" data-id="element-61">
      <div className="max-w-4xl mx-auto" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-63">
          <div className="text-4xl mb-4" data-id="element-64">🎁</div>
          <h2 className="text-3xl sm:text-4xl font-bold mb-12 text-gold-400" data-id="element-65">
            LO QUE TE LLEVAS HOY
          </h2>

          <div className="bg-white/5 border border-white/10 rounded-2xl p-8 mb-8 backdrop-blur-sm" data-id="element-66">
            <div className="w-full max-w-lg mx-auto mb-6 rounded-xl overflow-hidden" data-id="element-67">
              <img src="https://cdn.magicpatterns.com/uploads/jzYkYbQj3RgQxxnu9BPyhT/Captura_de_pantalla_2026-04-28_a_la(s)_10.48.10_p._m..png" alt="Clase en video" className="w-full object-contain" data-id="element-68" />
            </div>
            <div className="flex justify-center mb-6" data-id="element-69">
              <Sparkles className="w-12 h-12 text-gold-400" data-id="element-70" />
            </div>
            <h3 className="text-2xl font-bold mb-6" data-id="element-71">
              📚 3 CLASES COMPLETAS PARA ROMPER EL PATRON
            </h3>
            <div className="space-y-4 text-left max-w-lg mx-auto" data-id="element-72">
              <div className="border-l-2 border-gold-500 pl-4" data-id="element-73">
                <p className="font-bold text-gold-400" data-id="element-74">Día 1 - CONCIENCIA:</p>
                <p className="text-gray-300" data-id="element-75">
                  Descubre el origen real de tu patrón en el amor
                </p>
              </div>
              <div className="border-l-2 border-gold-500 pl-4" data-id="element-76">
                <p className="font-bold text-gold-400" data-id="element-77">Día 2 - INTERRUPCIÓN:</p>
                <p className="text-gray-300" data-id="element-78">
                  Rompe el ciclo que te mantiene atascada y saboteandote
                </p>
              </div>
              <div className="border-l-2 border-gold-500 pl-4" data-id="element-79">
                <p className="font-bold text-gold-400" data-id="element-80">
                  Día 3 - NUEVA IDENTIDAD:
                </p>
                <p className="text-gray-300" data-id="element-81">
                  Instala tu nueva versión que atrae amor
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-82">
            <motion.div whileHover={{
            y: -5
          }} className="bg-white/5 border border-white/10 rounded-2xl p-6 text-left" data-id="element-83">
              <div className="h-40 w-full mb-6 rounded-lg overflow-hidden relative" data-id="element-84">
                <img src="https://cdn.magicpatterns.com/uploads/moDq6NBg1jJDvBExNuo4Jw/Captura_de_pantalla_2026-04-21_a_la(s)_12.14.16_p._m..png" alt="Meditación Empoderarte" className="w-full h-full object-contain" data-id="element-85" />
              </div>
              <h4 className="text-xl font-bold text-gold-400 mb-2" data-id="element-86">
                🧘‍♀️ BONUS: 1 MEDITACIÓN EXCLUSIVA
              </h4>
              <p className="text-gray-300" data-id="element-87">
                Instala tu nueva voz interna para el Amor y la Abundancia,
                eliminando toda raiz negativa y de autosabotaje.
              </p>
            </motion.div>

            <motion.div whileHover={{
            y: -5
          }} className="bg-white/5 border border-white/10 rounded-2xl p-6 text-left" data-id="element-88">
              <div className="h-40 w-full mb-6 rounded-lg overflow-hidden relative" data-id="element-89">
                <img src="https://cdn.magicpatterns.com/uploads/7joaKc4g361oBEb3Vt9pbx/Captura_de_pantalla_2026-04-21_a_la(s)_12.16.03_p._m..png" alt="Leyes Universales Manifestadoras" className="w-full h-full object-contain" data-id="element-90" />
              </div>
              <h4 className="text-xl font-bold text-gold-400 mb-2" data-id="element-91">
                📖 BONUS: EBOOK "4 Leyes Universales"
              </h4>
              <p className="text-gray-300" data-id="element-92">
                4 Leyes Universales que aplique para manifestar el Amor de mi
                vida y Abundancia en mi Negocio
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}